import { Badge, type BadgeVariant } from '@/components/ui/badge'
import { formatDateTimeShort } from '@/lib/formatters'
import { cn } from '@/lib/utils'
import { type CarrierEligibility, EligibilityStatus, eligibilityStatusLabels } from '@/models/salesLead'

const STATUS_BADGE: Record<EligibilityStatus, BadgeVariant> = {
  [EligibilityStatus.ELIGIBLE]: 'success',
  [EligibilityStatus.NOT_ELIGIBLE]: 'secondary',
  [EligibilityStatus.NOT_CHECKED]: 'outline',
}

export function CarrierEligibilityRow({ row }: { row: CarrierEligibility }) {
  const eligible = row.status === EligibilityStatus.ELIGIBLE
  const detail = row.status === EligibilityStatus.NOT_CHECKED ? row.missingForCheck : row.notes

  return (
    <li
      className={cn(
        'flex items-start gap-3 rounded-md border p-3',
        eligible ? 'border-accent-green/40 bg-accent-green/10' : 'border-transparent bg-neutral-50'
      )}
    >
      <img src={row.iconUrl} alt="" className="mt-0.5 size-5 shrink-0 rounded-sm" />
      <div className="min-w-0 flex-1 space-y-1">
        <div className="flex flex-wrap items-center justify-between gap-x-2 gap-y-1">
          <span className={cn('font-medium whitespace-nowrap', !eligible && 'text-muted-foreground')}>
            {row.vendorName}
          </span>
          <Badge variant={STATUS_BADGE[row.status]}>{eligibilityStatusLabels[row.status]}</Badge>
        </div>
        {detail && (
          <p className="text-muted-foreground line-clamp-3 text-xs break-words" title={detail}>
            {detail}
          </p>
        )}
        {row.checkedAt && (
          <p className="text-muted-foreground text-xs">
            Checked {formatDateTimeShort(row.checkedAt)}
            {row.checkedByName && <> by {row.checkedByName}</>}
          </p>
        )}
      </div>
    </li>
  )
}
